export default __webpack_public_path__ + "static/media/add.3a439810.svg";